import * as React from 'react'
import { Icon } from '../../shared'
import { navLinks } from '../nav.data'
import './nav-mobile.scss'

export const NavMobile = (): JSX.Element => {
  const baseClass: string = 'nav-mobile'

  return (
    <div className={baseClass}>
      <div className="container flex items--center justify--center full-width full-height">
        <div className={`${baseClass}__link-wrapper`}>
          {navLinks.filter(link => link.mobileIcon).map(({ mobileIcon, path, clickHandler }) => (
            clickHandler ?
            <a
              key={path}
              href={path}
              className={`${baseClass}__link`}
              onClick={clickHandler}
            >
              <Icon icon={mobileIcon} />
            </a>
            :
            <a
              key={path}
              href={path}
              className={`${baseClass}__link`}
            >
              <Icon icon={mobileIcon} />
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}
